import { render, staticRenderFns } from "./OCRComponent.vue?vue&type=template&id=345f9350"
import script from "./OCRComponent.vue?vue&type=script&lang=js"
export * from "./OCRComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports